module.exports = __webpack_public_path__ + "img/4-3-1.b29740a8.png";